import { passengerTypeAction } from "../../../Actions/Index";
import { cancelPreBookingAction } from "../../../Actions/LogicActions/Booking/CancelPreBookingActoin";
import { bookPassOfferAction } from "../../../Actions/LogicActions/CMSOffers/bookPassOfferAction";
import { getPassOffersAction } from "../../../Actions/LogicActions/CMSOffers/GetPassOffersAction";
import { uiPreferencesAction } from "../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { IPassOffer } from "../../../app/api/getPassOffers";
import { IPassForm } from "../../../app/offers/OfferPassLeftSection";
import { PASSENGER_WITH_BIRTHDATE_TYPES } from "../../../config/global";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { checkoutTree } from "../../../Orchestrator/ConstantTree/CheckoutPage/CheckoutTree";
import { getRecoilStateValue, saveAtomToLocalStorage, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IOfferPassType } from "../../../Orchestrator/Types/Types/OffersResponse";
import { IBookingResponse, ICustomerContact, IUserResponse } from "../../../Orchestrator/Types/Index";
import { ICmsMonthlyPassOffer, ICmsTravelPassOffer } from "../../../Orchestrator/Types/Interface/ICMSOffers";
import dayjs from "dayjs";
import { OffersContext } from "../Context/OffersContext";
import { generatePassBookingPersistAtomKey, PASS_BOOKING_WHITELIST_ATOMS } from "../../../Orchestrator/Recoils/OfferAtoms";


class OfferDetailStep extends StepFlow {
  get stepName() {
    return "OfferDetail_step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.CMSOffers.OfferPass.Back,
        handler: async () => {
          updateRecoilState<IOfferPassType | null>("offerPassTypeAtom", null);
          updateRecoilState<ICmsMonthlyPassOffer | ICmsTravelPassOffer | null>("selectedCmsPassOfferAtom", null);

          updateRecoilState("selectedPassOfferAtom", null);
          updateRecoilState("passOfferResponseAtom", null);
          updateRecoilState("passFormValuesAtom", null);
          updateRecoilState("bookingResponseAtom", null);

          const context = this.getCtx<OffersContext>("offersContext");
          if (context) {
            context.routeTo = ["OffersInit_Step"];
            this.next();
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{
        startDate: dayjs.Dayjs,
        passengerType?: string
      }, void>({
        eventName: evtTree.CMSOffers.OfferPass.getOffers,
        handler: async ({ data }) => {
          if (data) {
            const { passengerType = "adults", startDate } = data;
            const selectedCmsPassOfferAtom = getRecoilStateValue<ICmsMonthlyPassOffer | ICmsTravelPassOffer | null>("selectedCmsPassOfferAtom");

            if (selectedCmsPassOfferAtom) {
              getPassOffersAction.setParams({
                selectedCmsPassOfferAtom: selectedCmsPassOfferAtom,
                startDate,
                passengerType
              });
              getPassOffersAction.execute();
            }
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.OfferPass.detailPage.Init,
        handler: async ({ }) => {
          await passengerTypeAction.execute();
          updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
          uiPreferencesAction.execute()
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ login: () => {} }, void>({
        eventName: evtTree.CMSOffers.OfferPass.Login,
        handler: async (data) => {
          const { login } = data.data!
          if (login) {
            // Save atom details to local storage
            for (const atomKey of PASS_BOOKING_WHITELIST_ATOMS) {
              const atomValue = getRecoilStateValue(atomKey);
              saveAtomToLocalStorage(generatePassBookingPersistAtomKey(atomKey), atomValue);
            }

            setTimeout(() => {
              sessionStorage.setItem("redirectAfterLogin", "/offers?continuePassBooking=true");
              login();
            })
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ selectedPassOffer: IPassOffer }, void>({
        eventName: evtTree.CMSOffers.OfferPass.confirmPass,
        handler: async ({ data }) => {
          const { selectedPassOffer } = data!;
          updateRecoilState<IPassOffer>("selectedPassOfferAtom", selectedPassOffer);

          bookPassOfferAction.setParams({
            selectedPassOffer: selectedPassOffer
          })
          await bookPassOfferAction.execute();

          if (isActionRunSuccessfully(bookPassOfferAction)) {
            this.eventBus.emit({
              eventName: evtTree.CMSOffers.OfferPass.detailPage.customerContact.Sync,
            })
          }
        },
      })
    )

    this.registerEventSubscription(
      this.eventBus.on<{ bookingId: string }, void>({
        eventName: evtTree.CMSOffers.OfferPass.Modify.Click,
        handler: async ({ data }) => {
          const { bookingId } = data!;
          updateRecoilState<IPassOffer | null>("selectedPassOfferAtom", null);
          cancelPreBookingAction.setParams({
            bookingId
          });
          await cancelPreBookingAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      this.eventBus.on<void, void>({
        eventName: checkoutTree.CustomerContact.Change,
        handler: async () => {
          this.eventBus.emit({
            eventName: evtTree.CMSOffers.OfferPass.detailPage.customerContact.Sync,
          })
        }
      })
    )

    this.registerEventSubscription(
      this.eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.OfferPass.detailPage.customerContact.Sync,
        handler: async () => {
          setTimeout(() => {
            const bookingResponse = getRecoilStateValue<IBookingResponse>('bookingResponseAtom');
            const customerContact = getRecoilStateValue<ICustomerContact>('customerContactStateAtom');
            const passFormValuesAtom = getRecoilStateValue<IPassForm>('passFormValuesAtom');
            const userData = getRecoilStateValue<IUserResponse>('checkoutUserDataAtom');


            if (!bookingResponse) return;
            if (!customerContact) return;

            const toRemember = !(customerContact.firstName === userData?.firstName && customerContact.lastName === userData?.lastName)

            const passengers = bookingResponse?.booking?.passengers || [];
            let newPassengers = passengers.map(passenger => {
              return {
                ...passenger,
                ...((PASSENGER_WITH_BIRTHDATE_TYPES.includes(passFormValuesAtom?.passengerType || "") && passFormValuesAtom?.birthDate) ? { dateOfBirth: passFormValuesAtom?.birthDate || null } : {}),
                detail: {
                  email: customerContact.email,
                  firstName: customerContact.firstName,
                  lastName: customerContact.lastName,
                  phoneNumber: customerContact.phoneNumber
                },
                remember: toRemember
              };
            })
            updateRecoilState("passengerStateAtom", newPassengers);
          }, 100)
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<{ formValues: IPassForm }, void>({
        eventName: evtTree.CMSOffers.OfferPass.formValuesChange,
        handler: async ({ data }) => {
          const { formValues } = data!;
          updateRecoilState<IPassForm>("passFormValuesAtom", formValues!);
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.FlowClose,
        handler: async () => {
          updateRecoilState("selectedPassBookingAtom", null);

          _eventBus.emit({
            eventName: "FLOW_CLOSE",
            data: "OffersFlow",
          });
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Offer Detail Step Execute...");
  }
}

export const OfferDetailStepDeclaration = new StepDefinition({
  stepName: "OfferDetail_step",
  stepClass: OfferDetailStep,
});
